import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { Store } from '@sama/app-state';
import { isDefined } from '@sama/js-core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ShapeState } from '../../../../../../cross-team-shared/annotation/shared/state/shape-state';
import { AbstractAnnotationStore } from '../../../../../../outputs/annotation/annotation-shared/state/root/abstract-annotation-store';
import { TaskWorkspaceStore } from '../../../../../h3ml/state/task-workspace-store';
import { ObjectlessFocusedShapeService } from '../../utils/objectless-focused-shape.service';
import { RootFocusedAnnotationService } from '../../utils/root-focused-annotation.service';

@Component({
  selector: 'h3-focused-timeline',
  templateUrl: './focused-timeline.component.html',
  styleUrls: ['./focused-timeline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FocusedTimelineComponent implements OnInit {
  frames$!: Observable<number[]>;
  storeId$!: Observable<number | string | undefined>;
  objectlessShapeStore$!: Observable<Store<ShapeState> | undefined>;

  protected isObjectEnabledProject!: boolean;

  private taskWorkspaceStore = inject(TaskWorkspaceStore);
  private store = inject(AbstractAnnotationStore);
  private objectlessFocusedShapeService = inject(ObjectlessFocusedShapeService);
  private focusedAnnotationService = inject(RootFocusedAnnotationService);

  ngOnInit() {
    this.isObjectEnabledProject = this.taskWorkspaceStore.isUsingObjects();
    this.objectlessShapeStore$ =
      this.objectlessFocusedShapeService.getFocusedShapeStore$();
    this.storeId$ = this.taskWorkspaceStore.isUsingObjects()
      ? this.focusedAnnotationService
          .getFocusedAnnotationId$()
          .pipe(map((id) => id?.toString()))
      : this.objectlessShapeStore$.pipe(
          map(() => this.objectlessFocusedShapeService.getFocusedShapeIndex()),
        );
    this.frames$ = this.store('focusedAreaRange').$.pipe(
      filter(isDefined),
      // fix me if you change this code
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
      filter((range) => !!range?.length),
      map((range) =>
        Array.from(
          { length: range[1] - range[0] + 1 },
          (_, index) => range[0] + index,
        ),
      ),
    );
  }
}
